import React from 'react';
import styled, { css } from 'styled-components';
import Label from '~/components/template/EventTimelineV2/components/Block/components/Data/components/Label';
import { BLUR_STYLES } from '../styles';
import { type AudioBlock as AudioBlockType } from '~/graphql/types';
import AudioPlayer from '~/components/molecule/AudioPlayer';

export type Props = Omit<AudioBlockType, '__typename' | 'value'> & {
  dataTestId?: string;
  src: string;
};

const AudioBlock: React.FC<Props> = ({ label, css, blurred, src }) => (
  <Container $css={css} $blurred={blurred || false}>
    {label && <Label>{label}</Label>}
    <AudioPlayer src={src} />
  </Container>
);

const Container = styled.div<{ $blurred: boolean; $css?: string | null }>(
  ({ theme, $blurred, $css }) => css`
    margin: ${theme.space('xxxs')} 0;

    ${$blurred && BLUR_STYLES};

    ${$css &&
    css`
      ${$css}
    `}
  `,
);

export default AudioBlock;
